import { useState } from "react";
import { Loader2, CheckCircle2 } from "lucide-react";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";

const inp = "w-full px-3 py-2 border border-zinc-300 text-sm focus:outline-none focus:border-[#0033FF] bg-white";

export const SupportForm = ({ sessionId, source = "form", initialMessage = "", onDone }) => {
  const { user } = useAuth();
  const [f, setF] = useState({ name: user?.name || "", email: user?.email || "", subject: "", message: initialMessage });
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const [ref, setRef] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault(); setBusy(true); setErr("");
    try {
      const { data } = await api.post("/support", { ...f, source, page: window.location.pathname, vizi_session_id: sessionId });
      setRef(data.ref); onDone?.(data.ref);
    } catch (e) {
      const d = e.response?.data?.detail;
      setErr(typeof d === "string" ? d : Array.isArray(d) ? "Please fill in every field." : "Couldn't send. Please try again.");
    } finally { setBusy(false); }
  };

  if (ref) {
    return (
      <div className="border border-[#0033FF]/30 bg-[#0033FF]/5 p-4 text-sm" data-testid="support-sent">
        <div className="flex items-center gap-2 font-bold text-[#0033FF] mb-1"><CheckCircle2 className="w-4 h-4" /> Sent: {ref}</div>
        <p className="text-zinc-600">The VizionCast team will reply to {f.email}, usually within one business day.</p>
      </div>
    );
  }
  return (
    <form onSubmit={submit} className="border border-zinc-200 bg-zinc-50 p-4 space-y-2" data-testid="support-form">
      <div className="text-[10px] tracking-[0.25em] uppercase font-bold text-[#0033FF]">Message the VizionCast team</div>
      {!user && (
        <div className="grid grid-cols-2 gap-2">
          <input data-testid="support-name-input" placeholder="Your name" value={f.name} onChange={set("name")} required className={inp} />
          <input data-testid="support-email-input" type="email" placeholder="Email" value={f.email} onChange={set("email")} required className={inp} />
        </div>
      )}
      <input data-testid="support-subject-input" placeholder="What's it about?" value={f.subject} onChange={set("subject")} required minLength={2} className={inp} />
      <textarea data-testid="support-message-input" placeholder="What happened? Include any error you saw." value={f.message} onChange={set("message")} required minLength={5} rows={3} className={inp} />
      {err && <div className="text-xs text-[#FF3B30]" data-testid="support-error">{err}</div>}
      <button data-testid="support-submit-btn" disabled={busy}
        className="w-full bg-zinc-900 text-white px-3 py-2.5 text-xs font-bold uppercase tracking-wider hover:bg-[#0033FF] disabled:opacity-50 inline-flex items-center justify-center gap-2">
        {busy && <Loader2 className="w-3.5 h-3.5 animate-spin" />} Send to the team
      </button>
      {sessionId && <p className="text-[11px] text-zinc-500">Your chat with Vizi is included so you don't have to repeat yourself.</p>}
    </form>
  );
};
